import { useState } from 'react'
import { UseFormRegister } from 'react-hook-form'

export default function Input({
    type,
    name,
    label,
    value,
    register,
    error,
}: {
    type: 'text' | 'textarea'
    name: string
    label: string
    value: string
    register: UseFormRegister<any>
    error?: string
}) {
    const [focused, setFocused] = useState(false)

    const handleFocus = () => setFocused(true)
    const handleBlur = () => setFocused(false)

    return (
        <div className="input group">
            <label
                htmlFor={name}
                className={`group-hover:text-white block relative pointer-events-none leading-6 duration-300 select-none pl-1
                    ${
                        focused || value
                            ? 'text-white top-0 text-xs'
                            : 'text-stone-400 top-[1.85rem]'
                    }
                `}
            >
                {label}
            </label>
            <div
                className={`group-hover:border-white border-[1px] duration-300 p-1 ${
                    focused || value ? 'border-white' : 'border-stone-400 '
                }`}
            >
                {type === 'text' && (
                    <input
                        type="text"
                        {...register(name)}
                        onFocus={handleFocus}
                        onBlur={handleBlur}
                        autoComplete="false"
                        className="block w-full bg-transparent outline-none group-hover:text-white group-hover:border-white"
                    />
                )}
                {type === 'textarea' && (
                    <textarea
                        {...register(name)}
                        onFocus={handleFocus}
                        onBlur={handleBlur}
                        rows={3}
                        className="block w-full bg-transparent outline-none resize-none group-hover:text-white group-hover:border-white"
                    />
                )}
            </div>

            {error && (
                <p className="text-red-600 text-sm animate-shakeErr select-none mt-2">
                    {error}
                </p>
            )}
        </div>
    )
}
